import { c as _c } from "react/compiler-runtime";
import { Button, type ButtonProps } from '@mantine/core';
import { HiDownload } from 'react-icons/hi';
import { DateTime as D } from 'luxon';
import { downloadBlob } from 'utils/download';
type DownloadButtonProps = {
  getContent?: () => string | Blob | null | undefined;
  filename: string;
  children?: React.ReactNode;
} & Omit<ButtonProps, 'onClick' | 'leftSection'>;
export const DownloadButton = t0 => {
  const $ = _c(14);
  let children;
  let filename;
  let getContent;
  let props;
  if ($[0] !== t0) {
    ({
      getContent,
      filename,
      children,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = filename;
    $[3] = getContent;
    $[4] = props;
  } else {
    children = $[1];
    filename = $[2];
    getContent = $[3];
    props = $[4];
  }
  const t1 = getContent == null || props.disabled;
  let t2;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <HiDownload />;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== filename || $[7] !== getContent) {
    t3 = () => {
      if (!getContent) {
        return;
      }
      const content = getContent();
      if (content == null) {
        return;
      }
      const blob = content instanceof Blob ? content : new Blob([content], {
        type: "text/csv"
      });
      downloadBlob(blob, filename);
    };
    $[6] = filename;
    $[7] = getContent;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const t4 = children ?? "Download";
  let t5;
  if ($[9] !== props || $[10] !== t1 || $[11] !== t3 || $[12] !== t4) {
    t5 = <Button {...props} disabled={t1} leftSection={t2} onClick={t3}>{t4}</Button>;
    $[9] = props;
    $[10] = t1;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};
export const downloadFileName = (name: string, ext = 'csv') => `${name}.${D.utc().toFormat('yyyy_MM_dd_T_HH_mm')}_UTC.${ext}`;